import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { count } from "rxjs/operators";
import { DataDirectoryService } from "../data-directory/data-directory.service";
import { HomeService } from "../home/home.services";
import { CostingPageService } from "./costing-page.service";
import { InvestmentCostingComponent } from "./investment-costing/investment-costing.component";

//parent
@Component({
  selector: "app-costing-page",
  templateUrl: "./costing-page.component.html",
  styleUrls: ["./costing-page.component.scss"],
})
export class CostingPageComponent implements OnInit {
  apiData: [];
  name = "Next";
  enableRegTab = false;
  enableBeStudyTab = false;
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  Molecule = false;
  searchValue = "";
  DragData: any = {};
  noData = false;
  apiCost: any;
  needRefresh: boolean; // to refresh child[investment-costig] api
  //  timeline: any;
  // sumOfAmount : number;
  // grant_total = [];
  //  timelineInvestment: [];

  constructor(
    private service: CostingPageService,
    private homeservice: HomeService,
    private directoryservice: DataDirectoryService
  ) {
    this.submolecules = [];
    this.directoryservice.serchKey = "";
  }

  //@ViewChild(InvestmentCostingComponent) child: InvestmentCostingComponent;

  ngOnInit(): void { }

  enableRegCostTab() {
    this.enableRegTab = true;
  }
  enableBeStudyTabFunc() {
    this.enableBeStudyTab = true;
  }

  clearFilter() {
    this.submolecules = [];
    this.selectedSubMolecule = {};
    this.Molecule = false;
    this.searchValue = "";
    this.subMolecule = false;
  }

  arrayToDropdown(InputArray) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues) => {
      let dropDownObj = {
        name: `${DropdownValues.brand_name},${DropdownValues.nda_number},${DropdownValues.dosage_forms}`,
        code: DropdownValues // store the full object for later use
      };
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }

  searchMolecule() {
    // this.sumOfAmount = 0;
    // this.grant_total = [];

    // console.log('this.child.grant_total', this.child.grant_total)
    this.submolecules = [];
    this.homeservice.getNdaData(this.searchValue).subscribe((ndaValues) => {
      console.log("Dropdown", ndaValues["data"].nda_numbers);
      if (ndaValues["data"].nda_numbers.length >= 1) {
        let dropdownvalues = this.arrayToDropdown(
          ndaValues["data"].nda_numbers
        );
        this.submolecules = dropdownvalues;
        this.subMolecule = true;
        this.Molecule = false;
        // this.child.grant_total = [];
      } else {
        this.selectedSubMolecule = {};
        this.subMolecule = false;
        this.Molecule = false;
      }
    });
  }

  getData() {
    console.log(this.selectedSubMolecule);
    if (this.selectedSubMolecule !== undefined) {
      let selectedMoleculeData = this.selectedSubMolecule["code"];
      console.log("nda value", selectedMoleculeData)
      let ndaValue = selectedMoleculeData["nda_number"]
      let brandValue = selectedMoleculeData["brand_name"]
      let DosageValue = selectedMoleculeData["dosage_forms"]
      let newData = {
        "nda_number": ndaValue,
        "brand_name": brandValue,
        "dosage_forms": DosageValue
      }
      this.needRefresh = false;
      this.homeservice.getDrugData(newData).subscribe((MoleculeData: any) => {
        if (MoleculeData !== null) {
          console.log("data", ndaValue);
          this.apiCost = MoleculeData;
          this.Molecule = true;
          this.DragData = MoleculeData;
          this.noData = false;
          localStorage.setItem("molecules", JSON.stringify(MoleculeData));
          // this.child.grant_total = [];
          // this.child.postAPICostDetails();
          // this.child.regulatoryDetails();
          // this.child.postBE_StudyDetails();
          // this.child.postRLD_StudyDetails();
          // this.child.postdfComplexity_cost_StudyDetails();
          // this.child.postIp_cost_StudyDetails();
          // this.child.grandTotalCalculation();
          this.needRefresh = true;
          //  this.timeline = MoleculeData;
        } else {
          this.noData = true;
          this.Molecule = false;
          this.DragData = {};
        }
      });
    }
  }
}
